import { useState, useEffect } from 'react';

interface TimelinePreferences {
  sidebarCollapsed: boolean;
  defaultRange: '24h' | '7d' | '30d';
  cardDensity: 'compact' | 'comfortable';
  savedViews: Array<{ name: string; params: Record<string, string> }>;
}

const DEFAULTS: TimelinePreferences = {
  sidebarCollapsed: false,
  defaultRange: '7d',
  cardDensity: 'compact',
  savedViews: []
};

const STORAGE_KEY = 'timeline_preferences';

export const useTimelinePreferences = () => {
  const [prefs, setPrefs] = useState<TimelinePreferences>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? { ...DEFAULTS, ...JSON.parse(stored) } : DEFAULTS;
    } catch {
      return DEFAULTS;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch {
      // localStorage unavailable — silent fail
    }
  }, [prefs]);

  const updatePref = <K extends keyof TimelinePreferences>(
    key: K,
    value: TimelinePreferences[K]
  ) => {
    setPrefs(prev => ({ ...prev, [key]: value }));
  };

  return { prefs, updatePref };
};
